export const ALL_USERS_QUERY = `
  query AllUsers {
    allUsers {
        id
        name
    }
  }
`
export const GET_STATISTICS_SUMMARY_QUERY = `
  query GetStatisticsSummary($fromDate: String, $toDate: String) {
    getStatisticsSummary(fromDate: $fromDate, toDate: $toDate) {
        eventId
        eventName
        count
        avgSeconds
        minSeconds
        maxSeconds
    }
  }
`
export const ALL_STATISTICS_QUERY = `
  query AllStatistics {
    allStatistics {
        id
        name
    }
  }
`
export const GET_STATISTICS_DETAIL_QUERY = `
  query GetStatisticsDetail($eventId: ID, $eventUserId: ID, $fromDate: String, $toDate: String, $start: Int) {
    getStatisticsDetail(eventId: $eventId, eventUserId: $eventUserId, fromDate: $fromDate, toDate: $toDate, start: $start) {
      totalRecordsFound
      recordsDisplayed
      start
      events {
        userId
        userName
        eventId
        eventName
        eventDate
        seconds
        info
      }
    }
  }
`
export const SEARCH_RESULTS_QUERY = `
  query SearchResults($id: ID!, $start: Int, $workspaceId: ID!, $inputs: [SearchInput], $sortColumn: String, $sortDir: String) {
    searchResults(id: $id, start: $start workspaceId: $workspaceId, inputs: $inputs, sortColumn: $sortColumn, sortDir: $sortDir) {
      search {
        id
        name
        objectType {
          id
          name
          stateful
        }
      }
      totalRecordsFound
      recordsDisplayed
      start
      details {
        id
        lineNumber
        field {
          id
          name
          type {
            id
            name
          }
        }
        show
        showColumnHeading
        outputHook
        subtotal
      }
      results
      userActions {
        id
        name
        type {
          id
          name
        }
      }
      fileJwt
    }
  }
`
export const CARD_ITEMS_QUERY = ` 
  query CardItems($cardId: ID!) {
    cardItems(cardId: $cardId) {
      id
      order
      type {
        id
        name
      }
      text
      privilege {
        id
        name
      }
      url
      search {
        id
        name
      }
      visibleRows
      showMore
      objectType {
        id
        name
      }
      showViewLink
      showQueryTitle
      showCreateLink
      showCalendarLink
      showPrintLink
      showExportLink
      showRecordsFound
      showRecordsDropDown
      showModifyLink
    }
  }
`
export const CURRENT_PAGE_QUERY = `
  query CurrentPage {
    currentPage {
      columns {
        id
        number
        width
        cards {
          id
          title
          privilege {
            id
            name
          }
          dropDown
          accessHook
        }
      }
    }
  }
`
export const CONFIGURATION_QUERY = `
  query Configuration($key: String!) {
    configuration(key: $key) {
      value
    }
  }
`
export const ACTIVITY_LOG_SUMMARY_QUERY = `
  query GetActionSummary($fromDate: String, $toDate: String) {
    getActionSummary(fromDate: $fromDate, toDate: $toDate) {
      objectTypeId
		  objectTypeName
		  actionTypeName
		  count
    }
  }
`
export const ACTIVITY_LOG_DETAIL_QUERY = `
  query GetActionDetail($objectTypeId: ID, $actionUserId: ID, $fromDate: String, $toDate: String, $start: Int) {
    getActionDetail(objectTypeId: $objectTypeId, actionUserId: $actionUserId, fromDate: $fromDate, toDate: $toDate, start: $start) {
      totalRecordsFound
      recordsDisplayed
      start
      actions {
        userId
        userName
        actionDate
        actionName
        objectId
        objectTypeName
      }
    }
  }
`
export const CREATE_MENU_ITEMS_QUERY = `
  query CreateMenuItems {
    createMenuItems {
      id
      name
    }
  }
`
export const WORKSPACE_MENU_ITEMS_QUERY = `
  query WorkspaceMenuItems {
    workspaceMenuItems {
      id
      name
    }
  }
`
export const USER_AREAS_QUERY = `
  query UserAreas {
    userAreas {
      areaStates {
        id
        state
      }
      areas {
        id
        name
        objectType {
          id
          name
        }
        items {
          id
          search {
            id
            name
          }
          sortOrder
          linkText
          linkUrl
          target
          hasPrompts
        }
      }
    }
  }
`
export const ADMIN_MENU_ITEMS_QUERY = `
  query AdminMenuItems {
    adminMenuItems {
      text
      href
      search {
        id
      }
    }
  }
`
export const CHOICES_QUERY = `
  query Choices($fieldId: ID!, $objectId: ID, $parentObjectId: ID) {
    choices(fieldId: $fieldId, objectId: $objectId, parentObjectId: $parentObjectId) {
      id
      name
      active
    }
  }
`
const FIELD_DETAIL = `
  id
  name
  columnName
  type {
    id
    name
    columnRequired
  }
  helpText
  width
  height
  maxLength
  permissionHook
  valueChangedHook
  validationHook
  behaviorHook
  defaultType {
    id
    name
  }
  defaultValue
  defaultString
  behaviorType {
    id
    name
  }
  choiceType {
    id
    name
  }
  choiceTableName
  choiceColumnName
  multiTableName
  choiceValue
  formatType {
    id
    name
  }
  formatValue
  inFilterType {
    id
    name
  }
  inFilterValue
  outFilterType {
    id
    name
  }
  outFilterValue
  searchInput
  searchOutput
  referenceTo {
    id
    name
  }
  keepDialogOpen
  incrementBy
  multipleRefs
  dataLoadHook
  dataStoreHook
  choicePkColumnName
  refListOrderBySql
  largeChoice
  largeChoiceHook
  autoComplete
  autoCompleteMinimumLength
  encrypt
  hasDependents,
  dependsOn {
    id
    name
    type {
      id
      name
    }
  }
`
const OBJECT_TYPE_DETAIL = `
  id
  name
  parent {
      id
      name
  }
  tableName
  systemType
  refOnly
  abstract
  notificationTemplate
  active
  pkColumnName
  stateful
  requiresWorkspace
  descriptiveField {
      id
      name
  }
  includeMostRecent
  fields {
    ${FIELD_DETAIL}
  }
  states {
      id
      name
  }
  forms {
      id
      name
      submitForm
      recordForm
      referenceForm
      active
      tabs {
          id
          name
          index
          active
          privilege {
              id
              name
          }
          tabFields {
              id
              field {
                ${FIELD_DETAIL}
              }
              xPosition
              yPosition
              colSpan
              tdOptions
              showLabel
              visible
              rowSpan
              sumColumn
          }
      }
  }
  actions {
    id
    name
    type {
      id
      name
      active
    }
    destinationState {
      id
      name
      active
    }
    finalizationHook
    notificationHook
    allowOwner
    notifyOwner
    active
  }
  userActions {
    id
    name
    type {
      id
      name
      active
    }
    destinationState {
      id
      name
      active
    }
    finalizationHook
    notificationHook
    allowOwner
    notifyOwner
    active
  }
`
export const OBJECT_TYPE_QUERY = `
  query ObjectType($id: ID!) {
    objectType(id: $id) {
      ${OBJECT_TYPE_DETAIL}
    }
  }
`
export const OBJECT_DETAIL = `
  id
  type {
    ${OBJECT_TYPE_DETAIL}
  }
  state {
    id
    name
  }
  owner {
    id
    name
  }
  parent {
    id
    type {
      id
      name
    }
  }
  active
  workspace {
    id
    name
  }
  actions {
    id
    name
    type {
      id
      name
    }
  }
  data
  defaults
  history {
    timeStamp
    displayName
    actionName
  }
  fileJwt
  inUse {
    objectId
    userId
    userName
    actionId
    actionName
    actionDate
}
`
export const OBJECT_QUERY = `
  query Object($id: ID!, $actionId: ID) {
    object(id: $id, actionId: $actionId) {
      ${OBJECT_DETAIL}
    }
  }
`
export const NEW_OBJECT_QUERY = `
  query NewObject($objectTypeId: ID!, $parentObjectId: ID) {
    newObject(objectTypeId: $objectTypeId, parentObjectId: $parentObjectId) {
      ${OBJECT_DETAIL}
    }
  }
`
export const SEARCH_QUERY = `
  query Search($id: ID!) {
    search(id: $id) {
      id
      name
      hasPrompts
      details {
        id
        lineNumber
        field {
          id
          name
          type {
            id
            name
          }
          choiceType {
            id
            name
          }
          choiceValue
        }
        fieldTypeOperators {
          id
          name
        }
        show
        sortDirection
        sortOrder
        filter
        prompt
        operator {
          id
          name
        }
        notOperator
        filterValue
        connector
        parenthesis
        sqlText
        outputHook
        width
        showColumnHeading
        subtotal
      }
    }
  }
`
export const JOBS_QUERY = `
  query Jobs {
    jobs {
        id
        lastDate
        nextDate
        totalTime
        broken
        interval
        failures
        procedure
    }
  }
`
export const QUERY_FIELDS_QUERY = `
  query QueryFields($objectTypeId: ID!) {
    queryFields(objectTypeId: $objectTypeId) {
      id
      name
    }
  }
`
export const QUERY_TABLE_EXISTS = `
  query TableExists($tableName: String!) {
    tableExists(tableName: $tableName)
  }
`
export const QUERY_COLUMN_EXISTS = `
  query ColumnExists($tableName: String!, $columnName: String!) {
    columnExists(tableName: $tableName, columnName: $columnName)
  }
`
export const QUERY_COPY_SEARCH = `
  query CopySearch($id: ID!) {
    copySearch(id: $id) {
      id
      name
    }
  }
`
export const JOBSITE_MULTI_SEARCH_QUERY = `
  query JobsiteMultiSearch($inputs: [JobsiteSearchInput]) {
    jobsiteMultiSearch(inputs: $inputs)
  }
`
export const OSR_JOBSITE_REPORT_QUERY = `
  query OSRJobsiteReport($inputs: OsrJobsiteReportInput) {
    osrJobsiteReport(inputs: $inputs) {
      modifyActionId
      reportData
    }
  }
`
export const LETTER_SEARCH_QUERY = `
  query LetterSearch($inputs: LetterSearchInput) {
    letterSearch(inputs: $inputs)
  }
`
export const CROSS_ENTITY_SEARCH_QUERY = `
  query CrossEntitySearch($inputs: CrossEntitySearchInput) {
    crossEntitySearch(inputs: $inputs)
    {
      sectionName
      sectionData {
        gridName
        gridData
      }
    }
  }
`
export const OSR_REPORT_QUERY = `
  query OSRReport($inputs: OsrReportInput) {
    osrReport(inputs: $inputs) {
      reportInfo {
        columnHeadings
        parameterValues {
            name
            value
        }
      }
      modifyActionId
      reportData
    }
  }
`
export const CALENDAR_ACTIVITY_REPORT_QUERY = `
  query CalendarActivityReport($inputs: CalendarActivityReportInput) {
    calendarActivityReport(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const COPY_EVENT_QUERY = `
  query CopyEvent($eventId: ID!) {
    copyEvent(eventId: $eventId) {
      newEventId
      modifyActionId
    }
  }
`
export const ACTIVITY_ACTIONS_QUERY = `
  query ActivityActions {
    activityActions {
      id
      name
    }
  }
`

export const STATES_QUERY = `
  query States($tenant: String) {
    states(tenant: $tenant) {
      id
      name
    }
  }
`
export const COUNTRIES_QUERY = `
  query Countries {
    countries {
      id
      name
    }
  }
`
export const USER_BY_EMAIL_QUERY = `
  query UserByEmail($email: String!) {
    userByEmail(email: $email) {
      id
      name
    }
  }
`
export const OBJECT_TYPE_BY_NAME_QUERY = `
  query ObjectTypeByName($name: String!) {
    objectTypeByName(name: $name) {
      id
      name
    }
  }
`
export const SEARCH_BY_NAME_QUERY = `
  query SearchByName($name: String!) {
    searchByName(name: $name) {
      id
      name
    }
  }
`
export const CALENDAR_REPORT_QUERY = `
  query CalendarReport($reportGroup: String!) {
    calendarReport(reportGroup: $reportGroup) {
      columnHeadings
      reportData
    }
  }
`
export const USER_CALENDARS_QUERY = `
  query UserCalendars {
    userCalendars {
      id
      name
    }
  }
`
export const PLAINTIFF_SEARCH_QUERY = `
  query PlaintiffSearch($inputs: PlaintiffSearchInput) {
    plaintiffSearch(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const DEADLINE_REPORT_QUERY = `
  query DeadlineReport($reportGroup: String!) {
    deadlineReport(reportGroup: $reportGroup)
  }
`
export const SERVICE_BUNDLES_QUERY = `
  query ServiceBundles($businessGroupId: ID!) {
    serviceBundles(businessGroupId: $businessGroupId) {
      id
      name
    }
  }
`
export const CURRENCY_DATES_QUERY = `
  query CurrencyDates($currencyId: ID!, $invoiceDate: String!) {
    currencyDates(currencyId: $currencyId, invoiceDate: $invoiceDate) {
      id
      startEffectiveDate
      echangeRateDollars
      currencyId
      exchangeRatePounds
      endEffectiveDate
    }
  }
`
export const CALENDAR_INJURIES_QUERY = `
  query CalendarInjuries($calendarId: ID) {
    calendarInjuries(calendarId: $calendarId) {
      id
      name
    }
  }
`
export const EMAIL_REPORT_QUERY = `
  query EmailReport($reportCode: String!, $reportGroup: String!) {
    emailReport(reportCode: $reportCode, reportGroup: $reportGroup)
  }
`
export const EXCLUSION_PROCEDURE_QUERY = `
  query ExclusionProcedure {
    exclusionProcedure
  }
`
export const EXCLUSION_STATUS_QUERY = `
  query ExclusionStatus {
    exclusionStatus {
      updated
      status
      taskName
    }
  }
`
export const OPERATORS_QUERY = `
  query Operators($fieldId: ID!) {
    operators(fieldId: $fieldId) {
      id
      name
    }
  }
`
export const SUBCATEGORIES_QUERY = `
  query Subcategories($categoryId: ID!) {
    subcategories(categoryId: $categoryId) {
      id
      name
    }
  }
`
export const FIELD_QUERY = `
  query Field($id: ID!) {
    field(id: $id) {
      id
      name
      type {
        id
        name
      }
      choiceType {
        id
        name
      }
      choiceValue 
      behaviorType {
        id
        name
      }
    }
  }
`
export const INVOICE_QUERY = `
  query Invoice($invoiceNumber: String!, $workspaceId: ID!) {
    invoice(invoiceNumber: $invoiceNumber, workspaceId: $workspaceId) {
        id
        number
        date
    }
  }
`
export const GROUP_NUMBER_RELATION_QUERY = `
  query GroupNumberRelation($groupId: ID!, $settlementId: ID!) {
    groupNumberRelation(groupId: $groupId, settlementId: $settlementId) 
  }
`
export const DATE_CLOSED_QUERY = `
  query DateClosed($casePlaintiffId: ID!) {
    dateClosed(casePlaintiffId: $casePlaintiffId) 
  }
`
export const BILLING_NUMBER_QUERY = `
  query BillingNumber($billingNumber: String!, $id: ID!) {
    billingNumber(billingNumber: $billingNumber, id: $id) 
  }
`
export const MONTH_END_TABLE_QUERY = `
  query MonthEndTable($tableName: String!, $id: ID!) {
    monthEndTable(tableName: $tableName, id: $id) 
  }
`
export const MONTH_END_DATE_QUERY = `
query MonthEndDate($date: String!, $id: ID!) {
  monthEndDate(date: $date, id: $id) 
}
`

export const MONTH_END_LIST_QUERY = `
query MonthEndList {
  monthEndList {
    id
    name
  }
}
`

export const ASBESTOS_AUDIT_REPORT_QUERY = `
  query AsbestosAuditReport($inputs: AsbestosAuditReportInput) {
    asbestosAuditReport(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const TRIAL_DATE_REPORT_QUERY = `
  query TrialDateReport($inputs: TrialDateInput) {
    trialDateReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const TRIAL_CALENDAR_REPORT_QUERY = `
  query TrialCalendarReport($inputs: TrialCalendarInput) {
    trialCalendarReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const NEW_LOSS_SETTLEMENT_REPORT_QUERY = `
  query NewLossSettlementReport($inputs: NewLossSettlementInput) {
    newLossSettlementReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const FORECAST_LOSS_SETTLEMENT_REPORT_QUERY = `
  query ForecastLossSettlementReport($inputs: ForecastLossSettlementInput) {
    forecastLossSettlementReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const DUPLICATE_SSN_REPORT_QUERY = `
  query DuplicateSSNReport {
    duplicateSSNReport {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const BORDEREAUX_REPORT_QUERY = `
  query BordereauxReport($inputs: BordereauxInput) {
    bordereauxReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`

export const AIG_REPORT_QUERY = `
  query AIGReport($inputs: AIGInput) {
    aigReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const AIG_UPDATED_PARAMETERS_REPORT_QUERY = `
  query AIGUpdatedParametersReport($inputs: AIGUpdatedParametersInput) {
    aigUpdatedParametersReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const POINT_IN_TIME_REPORT_QUERY = `
  query PointInTimeReport($inputs: PointInTimeInput) {
    pointInTimeReport(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const DAMAGES_SOUGHT_REPORT_QUERY = `
  query DamagesSoughtReport($inputs: DamagesSoughtInput) {
    damagesSoughtReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const VALUATION_PROJECTION_REPORT_QUERY = `
  query ValuationProjectionReport($inputs: ValuationProjectionInput) {
    valuationProjectionReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const VALUATION_PROJECTION_BY_CATEGORY_REPORT_QUERY = `
  query ValuationProjectionByCategoryReport($inputs: ValuationProjectionByCategoryInput) {
    valuationProjectionByCategoryReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const CIRCULAR_REFERENCES_QUERY = `
  query CircularReferences {
    circularReferences {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const TICKLER_REPORT_QUERY = `
  query TicklerReport {
    ticklerReport {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const PERIOD_BASED_REPORT_QUERY = `
  query PeriodBasedReport($inputs: PeriodBasedReportInput) {
    periodBasedReport(inputs: $inputs) {
      claimsEntered {
        total {
          name
          count
        }
        byDiagnosis {
          name
          count
        }
      }
      claimsClosed {
        total {
          name
          count
        }
        byDiagnosis {
          name
          count
          avgCost
        }
        bySettlementZeroPay {
          name
          count
        }
        bySettlementPositivePay {
          name
          count
        }
      }
      claimsWithChangeInStatus {
        name
        count
      }
      detail
    }
  }
`

export const BILLING_NUMBER_TK_QUERY = `
  query BillingNumberTK($billingNumberTK: String!, $id: ID!) {
    billingNumberTK(billingNumberTK: $billingNumberTK, id: $id) 
  }
`
export const TIME_PERIODS_QUERY = `
  query TimePeriods {
    timePeriods {
      timePeriod
      displayName
    }
  }
`
export const EMAIL_TIMEKEEPERS_REPORT_QUERY = `
  query EmailTimekeeperReport($timePeriod: String, $option: String) {
    emailTimekeeperReport(timePeriod: $timePeriod, option: $option)
  }
`
export const SERVICE_RIDER_QUERY = `
  query ServiceRider($caseId: ID!) {
    serviceRider(caseId: $caseId)
  }
`
export const PROCESS_TIMEKEEPER_FILE_QUERY = `
  query ProcessTimekeeperFile($fileName: String) {
    processTimekeeperFile(fileName: $fileName) {
      value
      label
    }
  }
`
export const PROCESS_CURRENCY_RATE_FILE_QUERY = `
  query ProcessCurrencyRateFile($fileName: String) {
    processCurrencyRateFile(fileName: $fileName) {
      lineNumber
      errorMessage
      fileContents
    }
  }
`
export const CREATE_PICKLIST_QUERY = `
  query CreatePicklist($inputs: CreatePicklistInput) {
    createPicklist(inputs: $inputs)
  }
`
export const CUSTOM_SELECT_LIST_QUERY = `
  query CustomSelectList($modelName: String!, $entityName: String!) {
    customSelectList(modelName: $modelName, entityName: $entityName) {
      id
      name
    }
  }
`
export const CASE_MANAGEMENT_REPORT_QUERY = `
  query CaseManagementReport($inputs: CaseManagementReportInput) {
    caseManagementReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const LOSS_SETTLEMENT_FUNDING_REPORT_QUERY = `
  query LossSettlementReportFundingRequest($inputs: LossSettlementFundingRequestInput) {
    lossSettlementReportFundingRequest(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const PLAINTIFF_YEARS_QUERY = `
  query PlaintiffYears {
    plaintiffYears {
      id
      name
    }
  }
`
export const CLAIM_ACTIVITY_REPORT_QUERY = `
  query ClaimActivityReport($inputs: ClaimActivityReportInput) {
    claimActivityReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const CLAIM_COUNTS_BY_DISEASE_REPORT_QUERY = `
  query ClaimCountsByDisease($inputs: ClaimCountsByDiseaseInput) {
    claimCountsByDisease(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const CLAIM_COUNTS_BY_STATE_REPORT_QUERY = `
  query ClaimCountsByState($inputs: ClaimCountsByStateInput) {
    claimCountsByState(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const RISK_SUMMARY_REPORT_QUERY = `
  query RiskSummary {
    riskSummary {
      columnHeadings
      reportData
    }
  }
`
export const AVERAGE_DEFENSE_COST_REPORT_QUERY = `
  query AverageCost($inputs: AverageCostInput) {
    averageCost(inputs: $inputs) {
      columnHeadings
      parameterValues {
          name
          value
      }
      reportData
    }
  }
`
export const SINGLE_FIELD_SEARCH_QUERY = `
  query SingleFieldSearch($inputs: SingleFieldSearchInput) {
    singleFieldSearch(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const PROCESS_LEDES_FILE_QUERY = `
  query ProcessLedesFile($fileName: String!) {
    processLedesFile(fileName: $fileName) {
      invoiceNumber
      invoiceDate
      invoiceAmount
      numberOfItems
      startTime
      endTime
      ledesErrors {
        lineNumber
        columnNumber
        errorMessage
        fileContents
      }
    }
  }
`
export const PROCESS_WORK_HISTORY_FILE_QUERY = `
  query ProcessWorkHistoryFile($fileName: String!) {
    processWorkHistoryFile(fileName: $fileName) {
      numberOfItems
      startTime
      endTime
      errors {
        lineNumber
        columnNumber
        errorMessage
        fileContents
      }
    }
  }
`
export const BOSSCI_CASE_SEARCH_QUERY = `
  query BosSciCaseSearch($inputs: BosSciCaseSearchInput) {
    bossciCaseSearch(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const BOSSCI_CASE_REPORT_QUERY = `
  query BosSciReport($inputs: CaseReportInput) {
    bossciCaseReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const PLAINTIFF_FIRM_REPORT_QUERY = `
  query PlaintiffFirmReport($inputs: PlaintiffFirmInput) {
    plaintiffFirmReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const PLAINTIFF_UPDATE_REPORT_QUERY = `
  query PlaintiffUpdate($inputs: PlaintiffUpdateInput) {
    plaintiffUpdate(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const AAG_PLAINTIFF_UPDATE_REPORT_QUERY = `
  query AAGPlaintiffUpdate($inputs: AAGPlaintiffUpdateInput) {
    aagPlaintiffUpdate(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const AAG_PLAINTIFF_REPORT_QUERY = `
  query AAGPlaintiffReport($inputs: AAGPlaintiffReportInput) {
    aagPlaintiffReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const PRODUCT_SURGERY_REPORT_QUERY = `
  query ProductSurgeryReport($inputs: ProductSurgeryInput) {
    productSurgeryReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const DUPLICATE_PLAINTIFF_REPORT_QUERY = `
  query DuplicatePlaintiffReport($inputs: DuplicatePlaintiffInput) {
    duplicatePlaintiffReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const QUARTERLY_AUDIT_REPORT_QUERY = `
  query QuarterlyAuditReport($inputs: QuarterlyAuditReportInput) {
    quarterlyAuditReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const RETRIEVEX_REPORT_QUERY = `
  query RetrievexReport($inputs: RetrievexReportInput) {
    retrievexReport(inputs: $inputs) {
      columnHeadings
      reportData
    }
  }
`
export const MASTER_CASE_LIST_QUERY = `
  query MasterCaseList {
    masterCaseList {
      columnHeadings
      reportData
    }
  }
`
export const PAID_DEFENSE_FEES_REPORT_QUERY = `
  query PaidDefenseFeesReport($inputs: PaidDefenseFeesInput) {
    paidDefenseFees(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const LIBERTY_MUTUAL_DEFENSE_FEES_QUERY = `
  query LibertyMutualDefenseFees($inputs: LibertyMutualDefenseFeesInput) {
    libertyMutualDefenseFees(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const LIBERTY_MUTUAL_2024_QUERY = `
  query LibertyMutual2024($inputs: LibertyMutualDefenseFeesInput) {
    libertyMutual2024(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const PAID_INDEMNITY_QUERY = `
  query PaidIndemnity($inputs: PaidIndemnityInput) {
    paidIndemnity(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const MEDICARE_NEW_QUERY = `
  query MedicareNew($inputs: MedicareNewInput) {
    medicareNew(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const ASBESTOS_CALENDAR_ACTIVITY_QUERY = `
query AsbestosCalendarActivityReport($inputs: AsbestosCalendarActivityInput) {
  asbestosCalendarActivityReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const REOPENED_CLAIMS_QUERY = `
query ReopenedClaimsReport($inputs: ReopenedClaimsInput) {
  reopenedClaimsReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const CASE_COUNT_WEEK_QUERY = `
query CaseCountWeekReport($inputs: CaseCountWeekInput) {
  caseCountWeekReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const PLAINTIFF_DEFENSE_FEE_REPORT_QUERY = `
query PlaintiffDefenseFeeReport($inputs: PlaintiffDefenseFeeInput) {
  plaintiffDefenseFeeReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const CLAIM_FILE_EXPORT_QUERY = `
query ClaimFileExport($inputs: ClaimFileExportInput) {
  claimFileExport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const LIST_INVOICES_QUERY = `
query ListInvoices($inputs: ListInvoicesInput) {
  listInvoices(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
    otherData
  }
}
`
export const INVOICE_DETAIL_REPORT_QUERY = `
query InvoiceDetailReport($inputs: InvoiceDetailInput) {
  invoiceDetailReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const MONTHLY_COUNT_REPORT_QUERY = `
query MonthlyCountReport($inputs: MonthlyCountInput) {
  monthlyCountReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const DEPOSITION_REPORT_QUERY = `
query DepositionReport($inputs: DepositionReportInput) {
  depositionReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const EXCLUSION_COUNT_CHANGES_REPORT_QUERY = `
query ExclusionCountChangesReport {
  exclusionCountChangesReport 
}
`
export const ASBESTOS_LOG_REPORT_QUERY = `
query LogReport($inputs: LogInput) {
  logReport(inputs: $inputs) 
}
`
export const DATA_QUALITY_REPORT_QUERY = `
query DataQualityReport($updateHistory: String) {
  dataQualityReport(updateHistory: $updateHistory) 
}
`
export const DATA_QUALITY_DETAIL_QUERY = `
query DataQualityDetail($inputs: DataQualityDetailInput) {
  dataQualityDetail(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
    otherData
  }
}
`
export const PENDING_BY_REPORT_QUERY = `
query PendingByReport($inputs: PendingByInput) {
  pendingByReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const COST_REPORT_QUERY = `
query CostReport($inputs: CostReportInput) {
  costReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const MEDICARE_REPORT_QUERY = `
query MedicareReport($inputs: MedicareInput) {
  medicareReport(inputs: $inputs) {
    columnHeadings
    parameterValues {
      name
      value
    }
    reportData
  }
}
`
export const WORK_HISTORY_REPORT_QUERY = `
query WorkHistoryReport($inputs: WorkHistoryInput) {
  workHistoryReport(inputs: $inputs) 
}
`
export const WORKFLOW_QUERY = `
query Workflow($objectTypeId: ID!) {
  workflow(objectTypeId: $objectTypeId) 
}
`
export const OBJECT_TYPE_SQL_QUERY = `
query ObjectTypeSQL($objectTypeId: ID!) {
  objectTypeSQL(objectTypeId: $objectTypeId) 
}
`
export const EXPORT_USER_OBJECTS_QUERY = `
query ExportUserObjects {
  exportUserObjects 
}
`
export const GET_REF_LIST_DATA_QUERY = `
query GetRefListData($objectId: ID!, $fieldId: ID!) {
  getRefListData(objectId: $objectId, fieldId: $fieldId) 
}
`
export const HAS_PRIVILEGE_QUERY = `
query HasPrivilege($privilegeId: ID!) {
  hasPrivilege(privilegeId: $privilegeId) 
}
`
export const MDL_DOCKET_VERIFIED_QUERY = `
query MdlDocketVerified($caseCourtId: ID!) {
  mdlDocketVerified(caseCourtId: $caseCourtId) 
}
`
export const JOURNAL_ENTRIES_QUERY = `
query JournalEntries($fieldId: ID!, $objectId: ID!) {
	journalEntries(fieldId: $fieldId, objectId: $objectId) {
		created
		createdBy {
			id
			name
		}
		note
	}
}
`
export const SCHEMAS_QUERY = `
query Schemas {
  schemas {
    name
    created
    inactive
    description
  }
}
`
export const ALL_USER_ATTRIBUTES_QUERY = `
query AllUserAttributes($userId: ID!) {
  allUserAttributes(userId: $userId) {
    userId
    id
    name
    value
    defaultValue
  }
}
`
export const ALL_POOL_STATISTICS_QUERY = `
query GetAllPoolStatistics {
  getAllPoolStatistics
}
`
export const GET_LOG_FILE_LIST_QUERY = `
query GetLogFileList {
	getLogFileList
}
`
export const GET_OPEN_FILES_LIST_QUERY = `
query GetOpenFilesList {
	getOpenFilesList
}
`
export const GET_LOG_FILE_QUERY = `
query GetLogFile($fileInfo: JSONObject!) {
	getLogFile(fileInfo: $fileInfo)
}
`
export const FWINVOICE_OUTSIDE_FIRMS_QUERY = `
query OutsideFirms {
	outsideFirms {
		id
		name
		active
	}
}
`
export const FILE_LIST_QUERY = `
  query FileList($fieldId: ID!, $fileTypeId: ID!) {
    fileList(fieldId: $fieldId, fileTypeId: $fileTypeId) {
      id
      name
    }
  }
`
export const SESSION_INFO_QUERY = `
  query SessionInfo {
    sessionInfo
  }
`
export const ACTIVE_SCHEMAS_QUERY = `
  query GetActiveSchemas {
    getActiveSchemas
  }
`
export const ALL_DIRECTORIES_QUERY = `
  query GetAllDirectories {
    getAllDirectories
  }
`
export const GET_DATAPUMP_JOBS_QUERY = `
  query GetDatapumpJobs {
    getDatapumpJobs
  }
`
export const MY_DEVICES_QUERY = `
  query MyDevices {
    myDevices {
      userId
      userAgent
      mfaCode
      authorized
      saveDevice
      dateCreated
      method
    }
  }
`
export const GET_AUTH_APP_CODE_QUERY = `
  query GetAuthAppCode {
    getAuthAppCode
  }
`
export const GET_QR_CODE_QUERY = `
  query GetQRCode {
    getQRCode
  }
`
export const BILLED_HOURS_FORM_DATA_QUERY = `
  query BilledHoursFormData {
    billedHoursFormData {
      yearMin
      yearMax
      timekeepers {
        id
        name
      }
    }
  }
`
export const BILLED_HOURS_REPORT_QUERY = `
  query BilledHoursReport($inputs: BilledHoursInput) {
    billedHoursReport(inputs: $inputs) {
      columnHeadings
      parameterValues {
        name
        value
      }
      reportData
    }
  }
`
export const GET_PROFILER_RUNS_QUERY = `
  query GetProfilerRuns {
    getProfilerRuns
  }
`
export const GET_PROFILER_RUN_DETAIL_QUERY = `
  query GetProfilerRunDetail($runId: ID!) {
    getProfilerRunDetail(runId: $runId)
  }
`
export const GET_PACKAGE_SOURCE_QUERY = `
  query GetPackageSource($owner: String!, $name: String!) {
    getPackageSource(owner: $owner, name: $name)
  }
`
export const EXECUTE_SQL_QUERY = `
  query ExecuteSQL($sql: String!) {
    executeSQL(sql: $sql)
  }
`
export const GET_OBJECT_HISTORY_QUERY = `
  query getObjectHistory($schema: String!, $actionType: ID!) {
    getObjectHistory(schema: $schema, actionType: $actionType)
  }
`
export const GET_REF_OBJECT_HISTORY_QUERY = `
  query getRefObjectHistory($schema: String!, $actionType: ID!) {
    getRefObjectHistory(schema: $schema, actionType: $actionType)
  }
`
export const USAGE_REPORT_QUERY = `
  query UsageReport {
    usageReport
  }
`

//------------- MUTATIONS -----------------
export const PROFILER_START_MUTATION = `
  mutation ProfilerStart {
    profilerStart
  }
`
export const PROFILER_STOP_MUTATION = `
  mutation ProfilerStop {
    profilerStop
  }
`
export const DELETE_PROFILER_RUN_MUTATION = `
  mutation DeleteProfilerRun($runId: ID!) {
    deleteProfilerRun(runId: $runId)
  }
`
export const SIGN_UP_MUTATION = `
  mutation SignUp($email: String!, $name: String!, $password: String!, $cellPhone: String, $host: String!, $captchaToken: String!) {
    signup(email: $email, name: $name, password: $password, cellPhone: $cellPhone, host: $host, captchaToken: $captchaToken)
  }
`
export const VERIFY_EMAIL_MUTATION = `
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`
export const JOB_ACTION_MUTATION = `
  mutation JobAction($id: ID, $action: String!, $inputs: JobInput) {
    jobAction(id: $id, action: $action, inputs: $inputs)
  }
`
export const EXECUTE_ACTION_MUTATION = `
  mutation ExecuteAction($input: ObjectInput!) {
    executeAction(input: $input)
  }
`
export const CANCEL_ACTION_MUTATION = `
  mutation CancelAction($objectId: ID!, $actionId: ID!) {
    cancelAction(objectId: $objectId, actionId: $actionId)
  }
`
export const SET_AREA_STATES_MUTATION = `
  mutation SetAreaStatesMutation($areaStates: [AreaStateInput]) {
    setAreaStates(areaStates: $areaStates) {
      id
      state
    }
  }
`
export const AUTHORIZE_MUTATION = `
  mutation Authorize($userId: ID!, $mfaCode: String!, $saveDevice: String!, $method: String!) {
    authorize(userId: $userId, mfaCode: $mfaCode, saveDevice: $saveDevice, method: $method)
  }
`
export const RESEND_MFA_CODE_MUTATION = `
  mutation ResendCode($userId: ID!, $method: String!) {
    resendCode(userId: $userId, method: $method)
  }
`
export const LOGIN_MUTATION = `
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      id
      name
      email
      cellPhone
      jwt
      mfa
      mfaMethod
      hasSecret
      mfaCodeExpireMinutes
      custom
    }
  }
`
export const LOGIN_AS_MUTATION = `
  mutation LoginAs($email: String!, $password: String!, $tenant: String!) {
    loginAs(email: $email, password: $password, tenant: $tenant) {
      id
      name
      email
      jwt
      custom
    }
  }
`
export const SET_USER_ATTRIBUTE_MUTATION = `
  mutation SetUserAttributeMutation($attributeName: String!, $attributeValue: String) {
    setUserAttribute(attributeName: $attributeName, attributeValue: $attributeValue) {
      userId
      id
      value
    }
  }
`
export const SAVE_USER_ATTRIBUTE_MUTATION = `
  mutation SaveUserAttributeMutation($userId: ID!, $attributeName: String!, $attributeValue: String) {
    saveUserAttribute(userId: $userId, attributeName: $attributeName, attributeValue: $attributeValue) {
      userId
      id
      value
    }
  }
`
export const FORGOT_PASSWORD_MUTATION = `
  mutation ForgotPassword($email: String!, $host: String!) {
    forgotPassword(email: $email, host: $host)
  }
`
export const RESET_PASSWORD_TOKEN_MUTATION = `
  mutation ResetPasswordToken($token: String!) {
    resetPasswordToken(token: $token)
  }
`
export const SET_PASSWORD_MUTATION = `
  mutation setPassword($userId: ID!, $newPassword: String!) {
    setPassword(userId: $userId, newPassword: $newPassword)
  }
`
export const DELETE_OBJECT_TYPE = `
  mutation DeleteObjectType($objectTypeId: ID!) {
    deleteObjectType(objectTypeId: $objectTypeId) 
  }
`
export const TOGGLE_SCHEMA_INACTIVE_MUTATION = `
  mutation ToggleSchemaInactive($schema: String!) {
    toggleSchemaInactive(schema: $schema)
  }
`
export const CREATE_SCHEMA_MUTATION = `
  mutation CreateSchema($schemaName: String!) {
    createSchema(schemaName: $schemaName)
  }
`
export const FINISH_COPY_MUTATION = `
  mutation FinishCopy($schemaName: String!) {
    finishCopy(schemaName: $schemaName)
  }
`
export const CREATE_DATABASE_USER_MUTATION = `
  mutation CreateDatabaseUser($user: String!, $password: String!) {
    createDatabaseUser(user: $user, password: $password)
  }
`
export const SET_DATABASE_USER_PASSWORD_MUTATION = `
  mutation SetDatabaseUserPassword($user: String!, $password: String!) {
    setDatabaseUserPassword(user: $user, password: $password)
  }
`
export const COPY_SCHEMA_MUTATION = `
  mutation CopySchema($sourceSchemaName: String!, $destinationSchemaName: String!) {
    copySchema(sourceSchemaName: $sourceSchemaName, destinationSchemaName: $destinationSchemaName)
  }
`
export const RESET_SCHEMA_MUTATION = `
  mutation ResetSchema($schemaName: String!) {
    resetSchema(schemaName: $schemaName)
  }
`
export const DROP_SCHEMA_MUTATION = `
  mutation DropSchema($schemaName: String!) {
    dropSchema(schemaName: $schemaName)
  }
`
export const EXPORT_SCHEMA_MUTATION = `
  mutation ExportSchema($schemaName: String!, $directoryName: String!, $options: JSONObject) {
    exportSchema(schemaName: $schemaName, directoryName: $directoryName, options: $options)
  }
`
export const IMPORT_SCHEMA_MUTATION = `
  mutation ImportSchema($fileName: String!, $directoryName: String!, $options: JSONObject) {
    importSchema(fileName: $fileName, directoryName: $directoryName, options: $options)
  }
`
export const REGISTER_AUTH_APP_MUTATION = `
mutation RegisterAuthApp {
	registerAuthApp
}
`
export const DELETE_USER_DEVICE_MUTATION = `
  mutation DeleteUserDevice($userAgent: String!) {
    deleteUserDevice(userAgent: $userAgent)
  }
`
export const UPDATE_BASIC_INFO_MUTATION = `
  mutation UpdateBasicInfo($inputs: JSONObject) {
    updateBasicInfo(inputs: $inputs)
  }
`
export const REBUILD_SCHEMA_TABLE_MUTATION = `
  mutation RebuildSchemaTable {
    rebuildSchemaTable
  }
`
